import * as React from 'react';
// import './App.css';

import ImgTransformer from './components/ImgTransformer';


class App extends React.Component {
  render() {
    return (
      <div className="App">
        <ImgTransformer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx